// extracted by mini-css-extract-plugin
module.exports = {"container":"_02712f2b3b--container--Rb1ph","icon":"_02712f2b3b--icon--agoE1","description":"_02712f2b3b--description--HGR2T","title":"_02712f2b3b--title--qg0Au"};